import React from 'react'
import gql from 'graphql-tag'
import DeliveredPhotos from 'components/shared/DeliveredPhotos'
import DefaultProductStatus from '../../DefaultProductStatus'
import CreateCollageButton from 'components/shared/CreateCollageButton'

const CollageProduct = ({match, product}) => {
  if (product.canProvideUserInput) {
    return (
      <CreateCollageButton
        collageUrl={product.createCollageUrl}
      />
    )
  }

  if (['delivered', 'awaiting_approval'].includes(product.state)) {
    return (
      <DeliveredPhotos
        estateId={match.params.estateId}
        product={product}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

CollageProduct.fragment = gql`
  fragment CollageProduct on CollageProduct {
    createCollageUrl(referer: "_referer_")
  }
`

export default CollageProduct
